<div class="recipients">
  <topo-data-table-server
    #table
    [isActive]="true"
    [tableHidden]="isTableLoading"
    [datasource]="datasource"
    [columns]="columDefs"
    [showHeader]="false"
    headerLabel="{{ 'COMMUNICATIONS.RECIPIENTS' | translate }}"
    [showRowGroups]="false"
    [embedded]="true"
    [rawHeight]="height"
    [rowHeight]="64"
    [getRowId]="getRowId"
    [autoFitColumns]="false"
    [showNewButton]="false"
    [showHeader]="true"
    [showSearch]="true"
    [showMenu]="true"
    [hideStateMenu]="true"
    [showRowGroups]="false"
    [showSystemFields]="true"
    [enableInfiniteScroll]="false"
    [enableServerSort]="true"
    [enableServerFilter]="true"
    [showSelectedCount]="showTableSelectedCount"
    (paginate)="onPaginate($event)"
    (takeChanged)="onTakeChanged($event)"
    (selectDocuments)="onSelectData($event)"
    (searchFilterChanged)="onSearchFilterChanged($event)"
    (storeUpdatedCalled)="onGridDataLoaded()"
    (exportToExcel)="onExportToExcel($event)"
    [skip]="skip"
    [take]="take"
    [totalCount]="totalCount">
    @if (selectedRecipients?.length > 0) {
      <div
        fxLayout="flex"
        fxLayoutAlign="start center">
        <topo-color-item-select
          [selectedUId]="selectedStepUId"
          [label]="selectedStatusName"
          [colorCode]="selectedStatusColorCode"
          itemLabel="statusName"
          itemColorCode="statusHtmlColorCode"
          [items]="workflowStatusListItems"
          (itemSelected)="multiWorkflowMoveStepSelected($event)"
        [isMedium]="true"></topo-color-item-select>
      </div>
    }
    <topo-confirm
      [isActive]="!!selectedStepUId"
      (respond)="confirmMoveWorkflowResponse($event)"
      title="{{ 'MAP.MOVE-DOCUMENTS-WORKFLOW-TITLE' | translate }}"
      message="{{ 'MAP.MOVE-DOCUMENTS-WORKFLOW-DESC' | translate : { status: selectedStatusName } }}"
      noText="{{ 'MAP.CONFIRM-NO' | translate }}"
      yesText="{{ 'MAP.CONFIRM-YES' | translate }}"
    icon="icon-workflow"></topo-confirm>
  </topo-data-table-server>
</div>

